
import {  googleLogout } from '@react-oauth/google';

import { axios_users_login } from '../axios/axios_users';
import { axios_googleapis_getrefreshtoken } from '../axios/axios_googleapis';

export const handlelogout =()=>{googleLogout();    localStorage.removeItem('token')  ;  }

// function saveavatartolocalstorage(url) {
//   if( window.location.hostname==='localhost'){return }
//     const xhr = new XMLHttpRequest();
//     xhr.open('GET', url); xhr.responseType = 'blob';  xhr.send();
//     xhr.onload = function() {
//       const reader = new FileReader();  reader.readAsDataURL(xhr.response);
//       reader.onloadend = function() { localStorage.setItem('imgavatar',reader.result) }
//     };
// }

export const getrefreshtokenandsave = async (response) => {
    localStorage.setItem('google_auth_calendar',response?.scope?.includes('calendar')? true : false)  ; 
    const  refreshtokenreq = await  axios_googleapis_getrefreshtoken(response.code) ;
    if(refreshtokenreq?.data?.error){   return false } ;
    localStorage.setItem('token',refreshtokenreq?.data?.accessToken)  ; 
    localStorage.setItem('calendar','google')  ; 

    // saveavatartolocalstorage(refreshtokenreq.data.urlavatar);
  return true
}


export const loginmailpass =  async (userdata) => {
  // console.log('loginmailpass',userdata) ; 
  const  refreshtokenreq = await  axios_users_login(userdata) ; 
  localStorage.setItem('token',refreshtokenreq.data.accessToken) ;
  localStorage.setItem('calendar','mutuello')  ; 

  return refreshtokenreq.data.error ? false : true
}
   


